import { jsxs, jsx } from "react/jsx-runtime";
import { Icon } from "@zapier/zinnia-icons";
import { useHeaderContext } from "../Header.js";
import { slugify } from "../../../utils/slugify.js";
import { Tag } from "../Tag/Tag.js";
import styles from "./SubmenuList.module.scss.js";
function SubmenuList(props) {
  const context = useHeaderContext();
  const headingID = slugify(`${props.parent}-submenu-heading-${props.heading}`);
  return /* @__PURE__ */ jsxs("div", { children: [
    /* @__PURE__ */ jsx(
      "div",
      {
        className: props.headingStyle === "strong" ? styles.strongHeading : styles.subtleHeading,
        id: headingID,
        children: props.heading
      }
    ),
    /* @__PURE__ */ jsx("ul", { className: styles.list, "aria-labelledby": headingID, children: props.items.map((item) => /* @__PURE__ */ jsx("li", { className: styles.listItem, children: /* @__PURE__ */ jsxs(
      "a",
      {
        className: styles.link,
        href: context.resolveURL(item.url),
        "aria-label": item.label,
        onClick: (e) => {
          context.emitLinkClickEvent(e, {
            interaction_name: "header_submenu_list_item_click",
            custom_tracking_fields: {
              parent: props.parent
            }
          });
        },
        ...item.openInNewTab && {
          target: "_blank",
          rel: "noreferrer"
        },
        children: [
          item.icon ? /* @__PURE__ */ jsx(
            "div",
            {
              className: styles.icon,
              "data-background": item.icon.background ?? "none",
              "data-color": item.icon.color,
              children: /* @__PURE__ */ jsx(Icon, { name: item.icon.name, size: 20 })
            }
          ) : item.image && /* @__PURE__ */ jsx("div", { className: styles.icon, "data-background": "none", children: /* @__PURE__ */ jsx(
            "img",
            {
              className: styles.image,
              src: item.image.url,
              alt: item.image.alt,
              loading: "lazy",
              width: 20,
              height: 20
            }
          ) }),
          /* @__PURE__ */ jsxs("div", { children: [
            /* @__PURE__ */ jsxs("div", { className: styles.label, children: [
              /* @__PURE__ */ jsx("span", { children: item.label }),
              item.tag && /* @__PURE__ */ jsx(Tag, { text: item.tag })
            ] }),
            item.description && /* @__PURE__ */ jsx("div", { className: styles.description, children: item.description })
          ] })
        ]
      }
    ) }, item.label)) })
  ] });
}
export {
  SubmenuList
};
